import React from 'react';

const BrandLink = ({ href, children, className = 'brand-link' }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >
    {children}
  </a>
);

export default BrandLink;
